import "./Icon.css";

const Icon = ({ Icon, href }) => {
  return (
    <a href={href} target="_blank">
      <div className="border w-10 h-10 !cursor-pointer border-Main flex justify-center hoverMain items-center after:bg-Main rounded-full transition-all relative overflow-hidden ">
        <Icon className="w-6 h-5 z-10 cursor-pointer" />
      </div>
    </a>
  );
};

export default Icon;
